export default __webpack_public_path__ + "static/media/PAFI_The Invitation of GMS 2022.7bb6467a.pdf";